// extracted by mini-css-extract-plugin
export default {"Root":"play-buttons_Root__1qMbF","button":"play-buttons_button__GFFSm","headers":"play-buttons_headers__aZZIJ"};